@use '../../../../../../../../styles/Colors.scss' as Colors;
@use '../../../../../../../../styles/Constants.scss' as Constants;

.dropdown_card_subtitle {
	font-size: Constants.$val-fontSizeXSmall;
	color: Colors.$col-greyInactive;
	margin-bottom: 0;
}

.bulk-edit-billable-status-modal{

	&__footer {
		display: flex;
		justify-content: space-between;
	}

	&__footer::after {
		content: none;
	}

	&__footer::before {
		content: none;
	}

	&__btn-container {
		display: flex;
		gap: Constants.$val-spacing-m;
	}
}

.materialNameCell {
	display: flex;
	flex-direction: row;
	align-items: center;

	.materialName {
		margin-left: Constants.$val-spacing-s;
	}
}
